var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 12H3.66797C2.01377 12 0.667969 10.6542 0.667969 9V3C0.667969 1.3458 2.01377 0 3.66797 0H9.66797C11.3222 0 12.668 1.3458 12.668 3V9C12.668 10.6542 11.3222 12 9.66797 12ZM3.66797 1C2.56517 1 1.66797 1.8972 1.66797 3V9C1.66797 10.1028 2.56517 11 3.66797 11H9.66797C10.7708 11 11.668 10.1028 11.668 9V3C11.668 1.8972 10.7708 1 9.66797 1H3.66797Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66953 8.89961C5.07043 8.89961 3.76953 7.59871 3.76953 5.99961C3.76953 4.40051 5.07043 3.09961 6.66953 3.09961C8.26863 3.09961 9.56953 4.40051 9.56953 5.99961C9.56953 7.59871 8.26863 8.89961 6.66953 8.89961ZM6.66953 4.05401C5.59673 4.05401 4.72393 4.92681 4.72393 5.99961C4.72393 7.07241 5.59673 7.94521 6.66953 7.94521C7.74233 7.94521 8.61513 7.07241 8.61513 5.99961C8.61513 4.92681 7.74233 4.05401 6.66953 4.05401Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96953 3.4C10.3561 3.4 10.6695 3.0866 10.6695 2.7C10.6695 2.3134 10.3561 2 9.96953 2C9.58293 2 9.26953 2.3134 9.26953 2.7C9.26953 3.0866 9.58293 3.4 9.96953 3.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.85d83b5d00864623d83ef88e1d157846.svg";
export { ForwardRef as ReactComponent };